'use strict'

/**
 * Svg Spriteを作成するアイコンファイル
 * - https://github.com/kisenka/svg-sprite-loader
 * - https://github.com/kisenka/svg-sprite-loader#examples
 */

// const files = require.context('@/assets/svgspriteicons/', false, /\.svg$/)
//
// console.log(files.keys().forEach(files))
//
// export default files.keys().forEach(files)

const cache = {}

function importAll(r) {
  r.keys().forEach((key) => {
    cache[key] = r(key)
  })
}

importAll(require.context('@/assets/svgspriteicons/', false, /\.svg$/))
// At build-time cache will be populated with all required modules.

export default cache
